import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";

interface NewsPreviewProps {
  items: NewsItem[];
}

export default function NewsPreview({ items }: NewsPreviewProps) {
  if (items.length === 0) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50 p-10 text-center text-sm text-foreground-500">
        暂无资讯
      </div>
    );
  }

  const [lead, ...rest] = items;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <Link
        to={`/news/${lead.id}`}
        className="group relative overflow-hidden rounded-lg bg-background-50 border border-background-200 cursor-pointer"
      >
        <div className="relative w-full h-56 md:h-64 overflow-hidden">
          <img
            src={lead.cover}
            alt={lead.title}
            title={`${lead.title} 资讯配图`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute top-3 left-3 rounded-md bg-accent-500 px-2 py-1 text-xs font-medium text-background-50">
            {lead.category}
          </span>
        </div>
        <div className="p-5">
          <p className="text-xs text-foreground-400">
            <i className="ri-calendar-line mr-1"></i>
            {lead.date}
          </p>
          <h3 className="mt-2 font-heading text-lg font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
            {lead.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">{lead.summary}</p>
        </div>
      </Link>

      <div className="flex flex-col">
        {rest.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="group flex items-start gap-4 py-4 border-b border-background-200 last:border-b-0 cursor-pointer"
          >
            <span className="w-14 h-14 rounded-lg overflow-hidden shrink-0 bg-secondary-200">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} 资讯配图`}
                className="w-full h-full object-cover"
              />
            </span>
            <div className="min-w-0">
              <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-400">
                {item.category} · {item.date}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}